import { render, staticRenderFns } from "./RegistrationStepper.vue?vue&type=template&id=61e2554a&"
import script from "./RegistrationStepper.vue?vue&type=script&lang=ts&"
export * from "./RegistrationStepper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports